import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitRenameClient = {
  client: string;
  name: string;
};

export const renameClient = async (data: SubmitRenameClient) => {
  const response = await axios.post(`${rootUrl}/psychologist/rename/client`, {
    client: data.client,
    token: getCookies('auth'),
    name: data.name,
  });

  return response.data;
};
